const getFileBaseUrl = () => {
  const apiUrl = import.meta.env.VITE_HOST_API || '';

  return apiUrl.replace(/\/client\/?$/, '');
};

export const normalizeFileUrl = (file: string) => {
  return file.startsWith('http://') || file.startsWith('https://')
    ? file
    : `${getFileBaseUrl()}${file}`;
};
